/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ShareCheckIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Share Check',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M17.722 6.332 12 0 6.292 6.332A1 1 0 0 0 7.035 8H10v9.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V8h2.979a1 1 0 0 0 .743-1.668ZM27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9Zm-2.338 14.312-4.128-4.127a.5.5 0 0 1 0-.707l1.036-1.036a.5.5 0 0 1 .707 0l2.731 2.731 6.106-6.106a.5.5 0 0 1 .707 0l1.043 1.043a.5.5 0 0 1 0 .707l-7.5 7.5a.5.5 0 0 1-.702-.005Z"
    />
    <path
      d="M14.7 27a12.272 12.272 0 0 1 .384-3H4V14h2v-4H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h13.75c-.026-.33-.05-.662-.05-1ZM20 16.893a12.226 12.226 0 0 1 4-1.809V11a1 1 0 0 0-1-1h-5v4h2Z"
    />
  </svg>`;
};
